var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3688 40.9547L67.417 29.2213V54.4985L44.3104 65.9014L44.3688 40.9547ZM15.2621 23.9582L41.0094 12.0748L64.5986 23.9753L41.4084 35.7809L15.2621 23.9582ZM40.8202 5.66406L6.67969 21.741L6.74015 37.6194L12.6214 40.5454L12.5756 28.6947L38.3687 41.0183L38.3089 66.2943L12.6214 52.9737L12.602 47.9435L6.67977 44.9971L6.72497 56.6413L40.767 74.294L73.3587 58.2103V21.7785L40.8202 5.66406Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 16.6955L28.4654 11.4141L62.1349 28.072L62.1451 38.6911L52.2321 43.0245V33.6559L17.2422 16.6955Z",
    fill: "#A9CF3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2344 68.5484V58.7814L62.1372 53.8438V63.8231L52.2344 68.5484Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorCaption);
export default __webpack_public_path__ + "static/media/vendor-caption.fad37e845e6fb8085cdc8f2d5adeffea.svg";
export { ForwardRef as ReactComponent };